var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.heads),function(head,index){return _c('th',{key:index},[_vm._v(" "+_vm._s(head)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }